import { Controller } from '@hotwired/stimulus'

// Generic skeleton: briefly shows a shimmer then removes itself.
export default class extends Controller {
  static values = { duration: Number }

  connect() {
    const ms = this.hasDurationValue ? this.durationValue : 300
    this.timeout = setTimeout(() => {
      this.element.remove()
    }, ms)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
